/*

Taken from https://github.com/ScottLogic/d3fc/blob/master/src/indicator/algorithm/calculator/slidingWindow.js

The MIT License (MIT)

Copyright (c) 2014-2015 Scott Logic Ltd.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
import noop from "./noop";
import { path, functor } from "./index";
export default function slidingWindow() {
    let undefinedValue = undefined, windowSize = 10, accumulator = noop, sourcePath, source, skipInitial = 0, misc;
    // eslint-disable-next-line prefer-const
    let slidingWindowFn = function (data) {
        const sourceFunction = source || path(sourcePath);
        const size = functor(windowSize).apply(this, arguments);
        const windowData = data.slice(skipInitial, size + skipInitial).map(sourceFunction);
        let accumulatorIdx = 0;
        const undef = functor(undefinedValue);
        return data.map(function (d, i) {
            if (i < (skipInitial + size - 1)) {
                return undef(sourceFunction(d), i, misc);
            }
            if (i >= (skipInitial + size)) {
                windowData.shift();
                windowData.push(sourceFunction(d, i));
            }
            return accumulator(windowData, i, accumulatorIdx++, misc);
        });
    };
    slidingWindowFn.undefinedValue = function (x) {
        if (!arguments.length) {
            return undefinedValue;
        }
        undefinedValue = x;
        return slidingWindowFn;
    };
    slidingWindowFn.windowSize = function (x) {
        if (!arguments.length) {
            return windowSize;
        }
        windowSize = x;
        return slidingWindowFn;
    };
    slidingWindowFn.misc = function (x) {
        if (!arguments.length) {
            return misc;
        }
        misc = x;
        return slidingWindowFn;
    };
    slidingWindowFn.accumulator = function (x) {
        if (!arguments.length) {
            return accumulator;
        }
        accumulator = x;
        return slidingWindowFn;
    };
    slidingWindowFn.skipInitial = function (x) {
        if (!arguments.length) {
            return skipInitial;
        }
        skipInitial = x;
        return slidingWindowFn;
    };
    slidingWindowFn.sourcePath = function (x) {
        if (!arguments.length) {
            return sourcePath;
        }
        sourcePath = x;
        return slidingWindowFn;
    };
    slidingWindowFn.source = function (x) {
        if (!arguments.length) {
            return source;
        }
        source = x;
        return slidingWindowFn;
    };
    return slidingWindowFn;
}
